import { Box } from '@mui/material';
import { PatientServiceItem, PatientServiceItemType } from '@uplift/api';
import { LightChip, TableCellDate, TableColumn } from '@uplift/ui-v2';
import { CompletedServiceItemPaymentAmount, ServiceItemPaymentAmount } from './ServiceItemPaymentAmount.component';
import { AppointmentState } from '@uplift/types';


export const paymentsOverviewMobileColumns = [
  {
    field: 'serviceDate',
    headerName: 'Date',
    flex: 1,
    renderCell: ({ row }) => (
      <Box display="flex" flexDirection="column" gap="4px">
        <span style={{ whiteSpace: 'nowrap' }}>{row.provider.name}</span>
        <span>
        Date of service: <TableCellDate value={row.serviceDate} />
        </span>
      </Box>
    ),
  } as TableColumn<PatientServiceItem, 'serviceDate'>,
  {
    field: 'provider',
    headerName: 'Provider',
    sortable: false,
    minWidth: 260,
    flex: 1,
    align: 'right',
    renderCell: ({ row }) => {
      return (
        <ServiceItemPaymentAmount row={row} label="Amount due" />
      );
    },
  } as TableColumn<PatientServiceItem, 'provider'>,
];


export const completedPaymentsOverviewMobileColumns = [
  {
    field: 'serviceDate',
    headerName: 'Date',
    flex: 1,
    renderCell: ({ row }) => {
      if (row.serviceType === PatientServiceItemType.appointment) {
        if (row.service.appointment.state === AppointmentState.cancelled) {
          return (
            <Box display="flex" flexDirection="column" gap="4px">
              <Box mb="4px">
                <LightChip label="Canceled" size="small" />
              </Box>
              <span style={{ whiteSpace: 'nowrap' }}>{row.provider.name}</span>
              <span>
                Date of service: <span style={{ textDecoration: 'line-through' }}><TableCellDate value={row.serviceDate} /></span>
              </span>
            </Box>
          );
        }
      }

      return (
        <Box display="flex" flexDirection="column" gap="4px">
          <span style={{ whiteSpace: 'nowrap' }}>{row.provider.name}</span>
          <span>
            Date of service: <TableCellDate value={row.serviceDate} />
          </span>
        </Box>
      );
    },
  } as TableColumn<PatientServiceItem, 'serviceDate'>,
  {
    field: 'provider',
    headerName: 'Provider',
    sortable: false,
    minWidth: 260,
    flex: 1,
    align: 'right',
    renderCell: ({ row }) => {
      if (!row.payment || !row.payment?.payment?.amountCents) {
        return (
          <Box display="flex" flexDirection="column" alignItems="flex-end">
            <span>No charge</span>
          </Box>
        );
      }

      return (
        <CompletedServiceItemPaymentAmount row={row} />
      );
    },
  } as TableColumn<PatientServiceItem, 'provider'>,
];
